import { Redirect } from "react-router-dom";
import { DASHBOARD_HOME_PATH } from "./dashboardNavigation";

const UserDashboardRedirect = () => <Redirect to={DASHBOARD_HOME_PATH} />;

export default UserDashboardRedirect;
